<template>
  <div>
    Gastrostomia
  </div>
</template>

<script>
export default {
  name: "QuestionGastrostomy",
  components: {},
  props: {
    questions: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>

<style scoped></style>
